// extracted by mini-css-extract-plugin
export default {"loginFormLabel":"LoginLabel_loginFormLabel__Jjbp2"};